export enum TradingAccountWidgetStatesEnum {
  CREATE_TRADING_ACCOUNT = "CREATE_TRADING_ACCOUNT",
  EDIT_TRADING_ACCOUNT = "EDIT_TRADING_ACCOUNT",
  VIEW_TRADING_ACCOUNT = "VIEW_TRADING_ACCOUNT",
  NO_TRADING_ACCOUNT = "NO_TRADING_ACCOUNT",
}
